import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `importer`; also keeps `excel-importer` from being read as a quote request id.
export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/excel-importer',
)({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/projects/$projectId/sourcing/quote-requests/importer',
            params: { projectId: params.projectId },
            search: true,
            replace: true,
        });
    },
});
